if (!customElements.get('klsh-mobile-purchase')) {
  customElements.define('klsh-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.info = this.productInfo?.querySelector('.product__info-container');
      this.button = this.querySelector('button');
      if (!this.info || !this.button) return;
      this.sync = this.sync.bind(this);
      this.onClick = () => {
        const submit = this.info.querySelector('product-form [type="submit"]');
        if (submit && !submit.disabled && submit.getAttribute('aria-disabled') !== 'true') submit.click();
      };
      this.button.addEventListener('click', this.onClick);
      this.info.addEventListener('change', this.sync, true);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      this.sync();
    }
    sync() {
      const submit = this.info.querySelector('product-form [type="submit"]');
      if (!submit) { this.hidden = true; return; }
      this.hidden = false;
      this.button.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      this.button.textContent = submit.querySelector('span:not(.sold-out-message)')?.textContent.trim() || submit.textContent.trim();
      const price = this.info.querySelector('.price .price-item--sale') || this.info.querySelector('.price .price-item--regular');
      if (price) this.querySelector('[data-price]').textContent = price.textContent.trim();
      const picker = this.info.querySelector('variant-selects');
      const options = picker ? Array.from(picker.querySelectorAll('input[type="radio"]:checked, .product-form__input--dropdown:not(.klsh-hemming__options) select')).map(input => input.value) : [];
      const length = this.info.querySelector('[data-klsh-hemming-length]');
      const label = length?.selectedOptions[0]?.textContent.split('—').pop().trim();
      if (label) options.push(label);
      this.querySelector('[data-selection]').textContent = options.filter(Boolean).join(' · ');
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.info?.removeEventListener('change', this.sync, true);
      this.button?.removeEventListener('click', this.onClick);
    }
  });
}
